import { render } from "./LiveDetail.vue?vue&type=template&id=42087bfa&scoped=true"
import script from "./LiveDetail.vue?vue&type=script&lang=js"
export * from "./LiveDetail.vue?vue&type=script&lang=js"

import "./LiveDetail.vue?vue&type=style&index=0&id=42087bfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42087bfa"]])

export default __exports__